import { Storage } from "aws-amplify";

export async function s3Upload(file, uniqueId) {
  const stored = await Storage.vault.put(uniqueId, file, {
    contentType: file.type
  });
  return stored.key;
}